'use strict';

angular.module('kerp-forms.forms')
  .service('CO_FCA_MAPPINGS', ['FormFieldMappings',
    function (FormFieldMappings) {

      this.mappings = function () {
        return FormFieldMappings
          .buildWithMappings({});
      };
    }]);
